const en = {
	inputPlaceHolder: 'Please enter in Chinese or English',
	error: 'Something is error, please try again later.',
	login: {
		loginTitle: 'Log in to PingPong Checkout',
		adminLogin: 'Admin Login',
		operatorLogin: 'Operator Login',
		email: 'Email',
		loginPwd: 'password',
		forgetPwd: 'Forget Password',
		login: 'Log in',
		noAccount: 'No account yet? ',
		register: 'Sign up for free',
		emailTip: 'Please enter your login email address',
		pwdTip: 'Please enter your login password',
		pwdLen: 'Password must be at least 6 digits',
		formatterEmail: 'Please enter the correct format of email address',
		noRegister:
      'This email is not used to register PingPong Checkout account. Please register first.',
		incorrect: 'Your username or password is incorrect. Please try again.',
		usernameError: 'Please enter your username',
		username: 'Username',
		operator: 'Operator login name',
		companyEmail: 'Register Email',
		passwordLabel: 'Password',
		accountBand: 'Opeator Disabled',
		authFailed: 'Authentication Failed',
		needRefreshGeeTest: 'Please perform human-machine verification again',
		captchaLoadFailed: 'Verification timed out. Please click Log in again.',
		passwordError:
      'Account temporarily locked due to verification issues. Auto-unlock in 3 hours. For security, avoid repeated login attempts.',
		verifyCodeError:
      'Your account is temporarily locked due to 5 consecutive failed SMS verification attempts. Auto-unlock in 3 hours. For security, avoid requesting or submitting new codes during this period.',
		errorTitle: 'Security Alert',
		poster: {
			title: 'Global Acquiring, Premium Choice',
			oneTitle: 'Open an account. Trade globally',
			oneDesc:
        'Acceptable payment methods include 260+ types from over 70 countries and regions.',
			twoTitle: 'Pay in over 50 global currencies',
			twoDesc: 'USD, HKD, JPY, SKW, GBP, IDR, etc.',
			threeTitle: 'High availability and stability',
			threeDesc:
        'Powerful API for fast integration, secure & stable transactions—protecting your business',
			fourTitle: 'Powerful product platform',
			fourDesc:
        'Comprehensive services, transaction analytics, order/risk/store management, and user administration'
		}
	},
	register: {
		registerTitle: 'Register PingPong Checkout',
		name: 'Contact Name',
		companyName: 'Company Name',
		website: 'Company Website',
		email: 'Register Email',
		accountManger: "Your account manager's name (optional)",
		mobileNum: 'Tel',
		verifyCode: 'Code',
		getValidate: 'Get code',
		agreement: "I've read and agreed to the PingPong ",
		agreementMerchant: 'the Merchant Service Agreement',
		registerNow: 'Register Now',
		nowLogin: 'login now',
		nameInput: 'Please enter your name',
		incorrectEmail: 'The format of email is incorrect',
		incorrectPhone: 'The format of cellphone number is incorrect',
		readAgreement:
      'Please confirm to read and agree to the Merchant Service Agreement',
		readAgreementV2:
      'Please confirm to read and agree to the User Agreement and Privacy Policy',
		sendValidate: 'The verification code was sent successfully.',
		errorValidate: 'The verification code is incorrect',
		resend: 'Resend',
		existMobile: 'The phone number has been registered, please change it.',
		existPhone: 'The phone number is registered',
		existEmail: 'The email address is registered',
		registerSuccess: 'Register Successfully',
		notice:
      'You have successfully registered! Please check your email to activate your account', // "You information is recorded and we will contact you recently. Please pay attention to your incoming call.",
		ok: 'OK',
		expireValidate: 'The verification code is invalid, please get it again',
		emptyEmail: 'Please enter your Email',
		emptyPhone: 'Please enter your Cellphone number',
		selectManager: 'Account Manager',
		type: 'Type',
		selectClientType: 'Register Type',
		emptyClientType: 'Please select your type',
		switchText: 'Have an account, ',
		nextStep: 'Next',
		emptyCompanyName: 'Please enter your company name',
		emptyWebsite: 'Please enter your company website',
		emptyRegisterAddress: 'Please select your business bases',
		registerAddress: 'Where is your business bases',
		openAccountDialog: {
			title: 'Enable PingPong Checkout',
			content:
        'You have registered for other PingPong services. You can now enable PingPong Checkout with one click and use the same login credentials.',
			confirm: 'Enable Now',
			cancel: 'Cancel'
		},
		accountExistsDialog: {
			title: 'Email Already Registered',
			content:
        'This email has been registered and verified for a different region. Please register with another email address.',
			confirm: 'Change Email',
			cancel: 'Cancel'
		}
	},
	forgetPwd: {
		forgetTitle: 'Forget Password',
		forgetSubTitle:
      'Please fill in the following information so we can confirm your identity.',
		phone: 'Phone Number',
		email: 'Email adreess',
		validateCode: 'Verification code',
		getValidateCode: 'Get a verification code',
		confirm: 'Confirm',
		backLogin: 'Return to login',
		incorrectPhone: 'The format of cellphone number is incorrect',
		notUsedPhone:
      'This phone number is not used to register PingPong Checkout account. Please register first.',
		notUsedEmail:
      'This email has not been registered PingPong Checkout. Please register first.',
		resend: 'Resend',
		phoneInput: 'Please enter your cellphone number',
		incorrectValidate: 'The verification code is incorrect',
		emptyValidate: 'Please enter the verification code',
		emptyEmail: 'Please enter your Email',
		incorrectEmail: 'The format of email is incorrect',
		newPwdSubTitle: 'Enter new password',
		newPwd: 'Please enter your password',
		confirmNewPwd: 'Please confirm your password',
		incorrectPwd: 'The format of password is incorrect',
		pwdRules:
      'Beginning with English, containing any two of number,uppercase and lowercase letters,6-20 characters',
		strong: 'Strong',
		normal: 'Normal',
		weak: 'Weak',
		secondInput: 'Password do not match.',
		successSubmit: 'Submit successfully',
		successModify: 'Reset successfully',
		newPwdtips:
      'Please login PingPong Checkout account with your new password. Note: Account will be locked if the password is modified multiple times in a short period of time. Please remember your password.',
		emailLabel: 'Enter email',
		verifyCodeLabel: 'Enter verification code',
		verifyCodeTip: 'Please enter the verification code displayed in the email',
		pwdLabel: 'Enter password',
		checkPwdLabel: 'Confirm password',
		verifyCodePhoneLabel: 'SMS verification code（SMS sent to{phoneNum})',
		sendValidate: 'The verification code was sent successfully.',
		expireValidate: 'The verification code is invalid, please get it again',
		errorValidate: 'The verification code is incorrect'
	},
	setNewPwd: {
		newPwd: 'Set your login password',
		fstPwd: 'We will ask you to change the default password for the first use',
		comfirmPwd: 'Re-Enter Password',
		nextLogin: 'Next time sign in, use your new password',
		mainLand: 'China Mainland',
		home: 'Home',
		product: 'Product',
		faq: 'Q&A'
	},
	account: {
		title: 'Fill in account information',
		emailTip: 'The email address will be used as your account login name',
		code: 'Email verification code',
		codeTip: 'Please enter the code shown in the email',
		createAndLogin: 'Create an account and log in',
		userProtocol: 'User Agreement',
		privacyProtocol: ' Privacy Policy ',
		service: 'Special Rules for Acquiring Services',
		usaSpecialTerms: 'USA Special Terms'

	},

	verifyCode: {
		title: 'SMS Verification Code',
		content:
      'A 6-digit verification code has been sent to your phone number {phoneNumber}. Please check and receive it.',
		subTitle: `Didn't receive the code? Resend now`,
		errorCode: 'Invalid verification code',
		getValidate: 'Get a verification code',
		resend: 'Resend',
		cancel: 'Cancel',
		continue: 'Continue',
		emptyValidate: 'Please enter the verification code',
		expireValidate: 'The verification code is invalid, please get it again',
		reviewText:
      'Your account is currently experiencing issues. Please try again later.'
	},
	passwordValidator: {
		title: 'Your password should '
	}
}
export default en
